import React from 'react';
import { Link } from 'react-router-dom';

function NavDate({selectedDate, setSelectedDate}) {
    const monthNow =  new Date().getMonth();
    const yearNow =  new Date().getFullYear();
    const daysMonth = new Date(yearNow, monthNow + 1, 0).getDate();
    const daysInMonth = Array.from({ length: daysMonth }, (_, i) => i + 1); // Days for this month
    const daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    
  return (
   <ul className='nav nav-pills d-flex flex-nowrap hover-scroll-x py-2 '>
     {daysInMonth.map((day) => {
        const tempDate = new Date(yearNow, monthNow, day);
        const dayName = daysShort[tempDate.getDay()];

        return(
            <Link key={day}
                className={ selectedDate.getDate() === day ? "nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 btn-active-primary active" : "nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px me-2 py-4 px-3 btn-active-primary" }
                onClick={() => setSelectedDate(new Date(yearNow, monthNow, day))}
            >
                <span className='opacity-50 fs-7 fw-semibold'>{dayName}</span>
                <span className='fs-6 fw-bold'>{day}</span>
            </Link>
        )
     })
     }
   </ul>
  );
}

export default NavDate;
